import Controller from '@ember/controller';
import updateAndSaveTask from 'garaje/utils/decorators/update-and-save-task';

class VisitorsSettingsVisitorTypesFlowPlusOneController extends updateAndSaveTask(Controller) {}

export default VisitorsSettingsVisitorTypesFlowPlusOneController;
